import React from "react";

import {
  ThemePreferences,
  LightTheme,
  generateUpdatedToggledThemeState,
  Theme,
  Typography,
  MainTypography
} from "./preferences/themePreferences";

export type Preferences = {
  theme: ThemePreferences;
};

type Action = {
  type: Actions;
  data?: any;
};

enum Actions {
  ToggleTheme = "ToggleTheme"
}

const initialState: Preferences = {
  theme: { isDarkMode: false, palette: LightTheme, typography: MainTypography }
};

const stateReducer = (state: Preferences = initialState, action: Action) => {
  switch (action.type) {
    case Actions.ToggleTheme: {
      return toggleTheme(state);
    }
    default: {
      throw new Error(`Unsupported action type: ${action.type}`);
    }
  }
};

const toggleTheme = (preferences: Preferences): Preferences => {
  return {
    ...preferences,
    theme: generateUpdatedToggledThemeState(preferences.theme.isDarkMode)
  };
};

type ContextState = [Preferences, React.Dispatch<Action>];

let StateContext: React.Context<ContextState> | undefined;

export const PreferencesProvider = (props: any) => {
  const [state, dispatch] = React.useReducer<
    React.Reducer<Preferences, Action>
  >(stateReducer, initialState);

  const initialContext: ContextState = [initialState, dispatch];
  StateContext = React.createContext(initialContext);
  const value = React.useMemo(() => [state, dispatch], [state]);
  return <StateContext.Provider value={value} {...props} />;
};

export const usePreferences = (): ContextState => {
  if (StateContext) {
    const context = React.useContext(StateContext);
    if (!context) {
      throw new Error(
        `usePreferences must be used within a PreferencesProvider`
      );
    }
    const [state, dispatch] = context;
    return [state, dispatch];
  } else {
    throw new Error(
      `usePreferences must be used within a  PreferencesProvider`
    );
  }
};

export type ThemeProps = {
  theme: {
    palette: Theme;
    typography: Typography;
  }

}